const MentorProfilePage = () => {
    return (
        <div>
            <h1>Mentor Profile</h1>
            <p>This is the mentor profile page.</p>
        </div>
    );
}
export default MentorProfilePage;